import { render, staticRenderFns } from "./TheBuyerLayout.vue?vue&type=template&id=558cb5e2&"
import script from "./TheBuyerLayout.vue?vue&type=script&lang=js&"
export * from "./TheBuyerLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports